export const DRUG_DETAIL_ACTION = 'DERUG_DETAIL_ACTION';
export const DRUG_SORT_ACTION = 'DERUG_SORT_ACTION';
